import request from "@/utils/request";

export function getIndex() {
  return request({
    url: "/student/index",
    method: "get",
  });
}
export function getNews(params) {
  return request({
    url: "/student/news/list",
    method: "get",
    params
  });
}


export function getXmList(data) {
  return request({
    url: "/student/xm/list",
    method: "post",
    data
  });
}

export function getXmHistory(data) {
  return request({
    url: "/student/xm/history",
    method: "post",
    data
  });
}

export function getXmDetail(data) {
  return request({
    url: "/student/xm/getById",
    method: "post",
    data
  });
}

export function getCourseList(data) {
  return request({
    url: "/student/recommendCourse/list",
    method: "post",
    data
  });
}

export function getStudyProgressByYear(data) {
  return request({
    url: "/student/getStudyProgressByYear",
    method: "post",
    data
  });
}

export function getSpecialList(data) {
  return request({
    url: "student/specialTopic/list",
    method: "post",
    data
  });
}

export function getCourseDetail(params) {
  return request({
    url: "/student/recommendCourse/getById" ,
    method: "get",
    params
  });
}

export function saveCourse(data) {
  return request({
    url: "/student/study/progress/save",
    method: "post",
    data,
    loading:false
  });
}

export function getRecommendCourseType() {
  return request({
    url: "/student/recommendCourseType/list",
    method: "post",
  });
}
export function getRecommendCourseList(data) {
  return request({
    url: "/student/recommendCourse/list",
    method: "post",
    data,
  });
}

export function getLives(data) {
  return request({
    url: "/student/live/list",
    method: "post",
    data
  });
}

export function getLiveDetail(params) {
  return request({
    url: "/student/live/details" ,
    method: "get",
    params
  });
}
